// extracted by mini-css-extract-plugin
module.exports = {"container":"_32gjig4smWUvPZi-Y4VZLr","omnibox":"_2roJzRq1Ph0xEuOcNb5eUE"};